import * as React from "react";
import { Box, Paper, Typography } from "@mui/material";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { colors } from "../brand";

function Field({ label, value, capitalize }) {
  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: "12px",
        background: colors.surfaceSoft,
        border: `1px solid ${colors.border}`,
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: 11.5,
          fontWeight: 700,
          color: colors.textSecondary,
          textTransform: "uppercase",
          letterSpacing: 0.4,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.3,
          fontSize: 15,
          fontWeight: 600,
          color: colors.textPrimary,
          wordBreak: "break-word",
          textTransform: capitalize ? "capitalize" : "none",
        }}
      >
        {value || "—"}
      </Typography>
    </Box>
  );
}

const UserPage = () => {
  const user = React.useMemo(() => {
    try {
      return JSON.parse(secureLocalStorage.getItem("profile"))?.results || {};
    } catch {
      return {};
    }
  }, []);
  const joined = user.createdAt
    ? `${moment(user.createdAt).format("D MMMM YYYY")} (${moment(
        user.createdAt,
      ).fromNow()})`
    : "";

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: "14px",
        border: `1px solid ${colors.border}`,
      }}
    >
      <Typography sx={{ fontWeight: 800, fontSize: 16, color: colors.textPrimary }}>
        Your details
      </Typography>
      <Typography sx={{ fontSize: 13, color: colors.textSecondary, mb: 2 }}>
        To change any of these, ask your system administrator.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(3, 1fr)" },
          gap: 1.5,
        }}
      >
        <Field label="First name" value={user.firstName} />
        <Field label="Last name" value={user.lastName} />
        <Field label="Email" value={user.email} />
        <Field label="Branch" value={user.branch} capitalize />
        <Field label="System role" value={user.userRole} />
        <Field label="Reconciliation role" value={user.reconciliation} />
        <Field label="Joined" value={joined} />
      </Box>
    </Paper>
  );
};

export default UserPage;
